import Table from './Table';
import TableHead from './TableHead';
import TableBody from './TableBody';
import TableFooter from './TableFooter';
import TableRow from './TableRow';
import TableCell from './TableCell';
import TableSortLabel from './TableSortLabel';
export { TableHead, TableBody, TableFooter, TableRow, TableCell, TableSortLabel, };
export default Table;
//# sourceMappingURL=index.js.map